import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';
import type {
  MarInstrumentDto,
  MarketAbuseChartResult,
  MarketAbuseFilterInput,
  MarketAbuseTableRecord,
  MarketAbuseTimeSpan,
  NotificationFilterInput,
  SaveInstrumentConditionInput,
  SettlementTimeAlertDto,
  VolumeAlertDto,
} from '@/api/types/marketAbuse';

const BASE = '/api/app/market-abuse';

export const marketAbuseApi = {
  getTradingVolume: (input: MarketAbuseFilterInput) =>
    http.get<PagedResult<MarketAbuseTableRecord>>(`${BASE}/trading-volume`, { params: input }).then((r) => r.data),
  getChartData: (input: MarketAbuseFilterInput) =>
    http.get<MarketAbuseChartResult>(`${BASE}/chart-data`, { params: input }).then((r) => r.data),
  getChartTableData: (input: MarketAbuseFilterInput) =>
    http.get<PagedResult<MarketAbuseTimeSpan>>(`${BASE}/chart-table-data`, { params: input }).then((r) => r.data),

  getInstruments: (symbol?: string | null) =>
    http.get<PagedResult<MarInstrumentDto>>(`${BASE}/instruments`, { params: { symbol, skipCount: 0, maxResultCount: 2000 } }).then((r) => r.data),
  saveInstrumentCondition: (input: SaveInstrumentConditionInput) =>
    http.post<string>(`${BASE}/save-instrument-condition`, input).then((r) => r.data),

  getSettlementTimeNotifications: (input: NotificationFilterInput) =>
    http.get<PagedResult<SettlementTimeAlertDto>>(`${BASE}/settlement-time-notifications`, { params: input }).then((r) => r.data),
  getVolumeNotifications: (input: NotificationFilterInput) =>
    http.get<PagedResult<VolumeAlertDto>>(`${BASE}/volume-notifications`, { params: input }).then((r) => r.data),
  getUnfilteredSettlementTimeNotifications: (input: NotificationFilterInput) =>
    http.get<PagedResult<SettlementTimeAlertDto>>(`${BASE}/unfiltered-settlement-time-notifications`, { params: input }).then((r) => r.data),
  getUnfilteredVolumeNotifications: (input: NotificationFilterInput) =>
    http.get<PagedResult<VolumeAlertDto>>(`${BASE}/unfiltered-volume-notifications`, { params: input }).then((r) => r.data),
  getNotificationCount: () => http.get<number>(`${BASE}/notification-count`).then((r) => r.data),
};
